import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class TermViewModel {
  public id: number;
  public sort_nr: number;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_html_de: string;
  public text_html_en: string;
  public get textHtml(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_html_en) ? this.text_html_de : this.text_html_en;
  }
}

export class TermConfirmationViewModel {
  public id: number;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public versionYMD: number;
  public versionHMS: number;
}

// Requests
export class TermSyncModel extends SyncModel {
}

// Responses
export class TermDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public release: boolean;
  public sort_nr: number;
  public intern_label: string;
  public label_de: string;
  public label_en: string;
  public text_html_de: string;
  public text_html_en: string;
  public version_ymd: number;
  public version_hms: number;
  public get version(): Moment {
    return Utils.GetMomentFromInt(this.version_ymd, this.version_hms);
  }
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class TermSyncDataModel extends SyncDataModel {
  public terms: TermDataModel[];
  public get models(): DataModel[] { return this.terms; }
  public DeserializeType(): void {
    this._DeserializeType(TermDataModel);
  }
}
